import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { MdClose, MdSearch } from "react-icons/md";

interface ViewSearchBarProps {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  showTabOptions: boolean;
  format?: "expanded" | "shrinked";
}

const ViewSearchBar: React.FC<ViewSearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  showTabOptions,
  format = "expanded",
}) => {
  // States definition
  const [text, setText] = useState("");

  /**
   * Send the current text as a search query on Enter key down
   * @param event
   */
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      // Execute the same function as clicking the icon
      handleLoupeClick()
    }
  };

  /**
   * Function used to define the filter by clicking the 
   * search icon
   */
  const handleLoupeClick = () => {
    // Set the text into the query
    setSearchQuery(text)

    // But also empty the text field
    setText("");
  }

  return (
    <>
      {!showTabOptions && <div className="w-[20%]" />}
      <div
        className={
          showTabOptions
            ? `${
                format === "expanded" ? "w-80" : "w-60"
              } flex-col justify-start items-start inline-flex`
            : "w-full flex-col justify-start items-start inline-flex"
        }
      >
        <div className="w-full h-[51px] bg-neutral-50 rounded-lg justify-start items-center gap-2 inline-flex relative">
          <div
            className="absolute mx-1.5 w-8 h-8 flex justify-center items-center cursor-pointer hover:bg-neutral-100 active:bg-neutral-200 ease-in-out duration-150 rounded-full"
            onClick={handleLoupeClick}
          >
            <MdSearch className="w-5 h-5 fill-neutral-500" />
          </div>
          <input
            id="search-input"
            aria-label="search-input"
            type="text"
            value={text}
            onChange={(event) => setText(event.target.value)}
            onKeyDown={handleKeyPress}
            className="w-full h-full p-3 pl-10 bg-transparent focus:outline-none text-neutral-600 placeholder:text-neutral-300 placeholder:select-none text-base font-normal font-sans leading-[19px]"
            placeholder="Search"
          />
          <AnimatePresence>
            {searchQuery && searchQuery.length > 0 && (
              <motion.div 
              initial={{opacity: 0, x: -40 }}
              animate={{opacity: 1, x: 0}}
              exit={{opacity: 0}}
              className="absolute right-3.5 w-fit h-8 px-2 inline-flex gap-1.5 justify-center items-center bg-accent-500 text-neutral-25 text-sm rounded-3xl">
                <div
                  className="w-4 h-4 bg-accent-600 hover:bg-accent-700 duration-150 ease-in-out rounded-full cursor-pointer"
                  onClick={() => setSearchQuery("")}
                >
                  <MdClose className="w-full h-full fill-neutral-25" />
                </div>
                {searchQuery}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
      {!showTabOptions && <div className="w-[20%]" />}
    </>
  );
};

export default ViewSearchBar;
